(function () {
  window.steepingInfoToggle = function (event, blockId) {
    event.preventDefault();
    const modal = document.getElementById('steeping-info-modal-' + blockId);
    modal.classList.toggle('cont_modal_active');
  };

  // Function to switch between tabs
  window.switchTab = function (event, blockId, tabNumber) {
    event.preventDefault();
    const modal = document.getElementById('steeping-info-modal-' + blockId);

    // Remove active class from all tabs and content in this block
    const allTabs = modal.querySelectorAll('.cont_tabs');
    const allContent = modal.querySelectorAll('.tab-content');

    allTabs.forEach(tab => tab.classList.remove('active'));
    allContent.forEach(content => content.classList.remove('active'));

    // Add active class to selected tab and content
    const selectedTab = modal.querySelector(`.cont_tabs[data-tab="${tabNumber}"]`);
    const selectedContent = modal.querySelector(`.tab-content[data-tab-content="${tabNumber}"]`);

    if (selectedTab) selectedTab.classList.add('active');
    if (selectedContent) selectedContent.classList.add('active');
  };

  // Function to switch between photo tabs
  window.switchPhotoTab = function (event, blockId, tabNumber) {
    event.preventDefault();
    const modal = document.getElementById('steeping-photo-modal-' + blockId);

    // Remove active class from all tabs and content in this block
    const allTabs = modal.querySelectorAll('.photo_tab');
    const allContent = modal.querySelectorAll('.photo_tab_content');

    allTabs.forEach(tab => tab.classList.remove('active'));
    allContent.forEach(content => content.classList.remove('active'));

    // Add active class to selected tab and content
    const selectedTab = modal.querySelector(`.photo_tab[data-tab="${tabNumber}"]`);
    const selectedContent = modal.querySelector(`.photo_tab_content[data-tab-content="${tabNumber}"]`);

    if (selectedTab) selectedTab.classList.add('active');
    if (selectedContent) selectedContent.classList.add('active');
  };

  // Helper to process JSON data and convert it into icon tags
  function processJsonData(jsonData, targetContainer, className) {
    if (Array.isArray(jsonData)) {
      jsonData.forEach(item => {
        let key = item.title || item.label || item.key || '';
        let value = item.content || item.value || '';
        if (key && value) {
          const listItem = document.createElement('div');
          listItem.className = className;
          listItem.innerHTML = parseIconTags(`[${key}]: ${value}`);
          targetContainer.appendChild(listItem);
        }
      });
    } else if (jsonData && typeof jsonData === 'object') {
      Object.entries(jsonData).forEach(([key, value]) => {
        if (key && value) {
          const listItem = document.createElement('div');
          listItem.className = className;
          listItem.innerHTML = parseIconTags(`[${key}]: ${value}`);
          targetContainer.appendChild(listItem);
        }
      });
    }
  }

  // Function to convert line-break separated content into list items
  function formatDescriptionAsList() {
    const descriptions = document.querySelectorAll('.steeping-info-block .cont_description');

    descriptions.forEach(descContainer => {
      const richTextField = descContainer.querySelector('.metafield-rich_text_field p') || descContainer.querySelector('p') || descContainer;

      if (richTextField && !richTextField.hasAttribute('data-formatted')) {
        // Mark as formatted to prevent double processing
        richTextField.setAttribute('data-formatted', 'true');

        // Check if the content is JSON
        const rawText = richTextField.textContent.trim();
        if (rawText.startsWith('{') || rawText.startsWith('[')) {
          try {
            const jsonData = JSON.parse(rawText);
            richTextField.innerHTML = '';
            processJsonData(jsonData, richTextField, 'steeping-list-item');
            return;
          } catch (e) {
            // Not valid JSON, fallback to line breaks
          }
        }

        // Get the text content
        const textContent = richTextField.innerHTML;

        // Split by <br> tags
        const items = textContent.split(/<br\s*\/?>/i).filter(item => item.trim() !== '');

        if (items.length > 0) {
          // Clear the original content
          richTextField.innerHTML = '';

          // Create list items with borders
          items.forEach((item, index) => {
            const listItem = document.createElement('div');
            listItem.className = 'steeping-list-item';
            listItem.innerHTML = parseIconTags(item.trim());
            richTextField.appendChild(listItem);
          });
        }
      }
    });
  }

  // Function to parse [icon-name] tags and replace with images
  function parseIconTags(text) {
    const iconBaseUrl = 'https://cdn.shopify.com/s/files/1/0898/5500/0944/files/';

    // Check if text contains icon pattern
    const iconMatch = text.match(/\[([^\]]+)\]:\s*(.*)/);

    if (iconMatch) {
      const iconName = iconMatch[1].trim();
      const textContent = iconMatch[2].trim();
      const iconUrl = iconBaseUrl + iconName + '.png';

      return `<div class="steeping-icon-wrapper"><img src="${iconUrl}" alt="${iconName}" class="steeping-icon"></div><div class="steeping-text">${textContent}</div>`;
    }

    // If no icon pattern, just return the text wrapped in text div
    return `<div class="steeping-text">${text}</div>`;
  }

  // Function to format photo tab content with icon parsing
  function formatPhotoTabContent() {
    const photoContents = document.querySelectorAll('.steeping-photo-only .steeping_instruction_content');

    photoContents.forEach(contentDiv => {
      if (contentDiv && !contentDiv.hasAttribute('data-formatted')) {
        // Mark as formatted to prevent double processing
        contentDiv.setAttribute('data-formatted', 'true');

        // Check if the content is JSON
        const rawText = contentDiv.textContent.trim();
        if (rawText.startsWith('{') || rawText.startsWith('[')) {
          try {
            const jsonData = JSON.parse(rawText);
            contentDiv.innerHTML = '';
            processJsonData(jsonData, contentDiv, 'steeping-list-item-wrapper');
            return;
          } catch (e) {
            // Not valid JSON, fallback to HTML parser
          }
        }

        // Look for metafield rich text field first
        const richTextField = contentDiv.querySelector('.metafield-rich_text_field p') || contentDiv.querySelector('p');

        if (richTextField) {
          // Get the HTML content and split by <br> tags
          const htmlContent = richTextField.innerHTML;
          const items = htmlContent.split(/<br\s*\/?>/i).filter(item => item.trim() !== '');

          // Clear the content
          contentDiv.innerHTML = '';

          // Process each item
          items.forEach(text => {
            const trimmedText = text.trim();

            // Check if this item has an icon pattern
            const iconMatch = trimmedText.match(/\[([^\]]+)\]:\s*(.*)/);

            if (iconMatch) {
              const iconName = iconMatch[1].trim();
              const textContent = iconMatch[2].trim();
              const iconBaseUrl = 'https://cdn.shopify.com/s/files/1/0898/5500/0944/files/';
              const iconUrl = iconBaseUrl + iconName + '.png';

              // Create wrapper for this item
              const itemWrapper = document.createElement('div');
              itemWrapper.className = 'steeping-list-item-wrapper';
              itemWrapper.innerHTML = `<div class="steeping-icon-wrapper"><img src="${iconUrl}" alt="${iconName}" class="steeping-icon"></div><div class="steeping-text">${textContent}</div>`;
              contentDiv.appendChild(itemWrapper);
            } else if (trimmedText) {
              // No icon, just add the text if not empty
              const textDiv = document.createElement('div');
              textDiv.className = 'steeping-text';
              textDiv.innerHTML = trimmedText;
              contentDiv.appendChild(textDiv);
            }
          });
          return; // Exit early since we processed the metafield
        }

        // Fallback: Get all paragraph elements
        const paragraphs = contentDiv.querySelectorAll('p');

        if (paragraphs.length > 0) {
          // Clear the content
          contentDiv.innerHTML = '';

          // Process each paragraph
          paragraphs.forEach(p => {
            const text = p.innerHTML.trim();

            // Check if this paragraph has an icon pattern
            const iconMatch = text.match(/\[([^\]]+)\]:\s*(.*)/);

            if (iconMatch) {
              const iconName = iconMatch[1].trim();
              const textContent = iconMatch[2].trim();
              const iconBaseUrl = 'https://cdn.shopify.com/s/files/1/0898/5500/0944/files/';
              const iconUrl = iconBaseUrl + iconName + '.png';

              // Create wrapper for this item
              const itemWrapper = document.createElement('div');
              itemWrapper.className = 'steeping-list-item-wrapper';
              itemWrapper.innerHTML = `<div class="steeping-icon-wrapper"><img src="${iconUrl}" alt="${iconName}" class="steeping-icon"></div><div class="steeping-text">${textContent}</div>`;
              contentDiv.appendChild(itemWrapper);
            } else {
              // No icon, just add the text
              const textDiv = document.createElement('div');
              textDiv.className = 'steeping-text';
              textDiv.innerHTML = text;
              contentDiv.appendChild(textDiv);
            }
          });
        } else {
          // Fallback: no paragraphs, treat as single text
          const htmlContent = contentDiv.innerHTML;
          const parsedContent = parseIconTags(htmlContent);
          contentDiv.innerHTML = parsedContent;
        }
      }
    });
  }

  function initializeSteepingBlocks() {
    // Find all steeping info modals and make them active
    const modals = document.querySelectorAll('[id^="steeping-info-modal-"]');
    modals.forEach(modal => {
      modal.classList.add('cont_modal_active');
    });

    // Format descriptions as lists
    formatDescriptionAsList();

    // Format photo tab content
    formatPhotoTabContent();
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSteepingBlocks);
  } else {
    // DOM is already loaded, run immediately
    initializeSteepingBlocks();
  }

  // Also run when Shopify sections are loaded/updated
  document.addEventListener('shopify:section:load', initializeSteepingBlocks);
  document.addEventListener('shopify:section:reorder', initializeSteepingBlocks);

  // Run after a short delay to catch any late-loading content
  setTimeout(initializeSteepingBlocks, 100);
})();
